export * from './App'

export const User = null

export const Press = {
  Articles: []
}
